import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';

export function useDeleteWorkshopMutation(workshopId: number, mode: 'soft' | 'hard') {
  const apiClient = useApiClient();
  return useMutation<InferFetchData<typeof deleteWorkshop>, ApiError, undefined>({
    mutationKey: ['DeleteWorkshop', workshopId, mode],
    mutationFn: () => throwOnError(deleteWorkshop(apiClient, workshopId, mode)),
  });
}

async function deleteWorkshop(apiClient: ApiClient, workshopId: number, mode: 'soft' | 'hard') {
  return apiClient.DELETE('/op/v2/workshops/{workshop_id}', {
    params: {
      path: {
        workshop_id: workshopId,
      },
    },
    body: {
      mode,
    },
  });
}
